import type { Theme } from '@mui/material/styles';

export const inlineEditTriggerButtonStyles = {
	desktopButton: {
		minWidth: 0,
		alignSelf: 'center',
		fontWeight: 700,
		textTransform: 'uppercase',
		fontSize: '0.75rem',
		lineHeight: 1.5,
		color: 'text.secondary',
		paddingY: 0.5,
		paddingX: 1,
		'& .MuiButton-startIcon': {
			marginRight: 0.5
		},
		'& .MuiButton-startIcon svg': {
			fontSize: '0.875rem'
		}
	},

	desktopButtonVisibility: (touchEditVisible: boolean) => (theme: Theme) => ({
		display: 'none',
		opacity: 0,
		pointerEvents: 'none',
		transition: 'opacity 120ms ease-in-out',
		'@media (hover: hover)': {
			display: 'inline-flex'
		},
		[theme.breakpoints.up('md')]: {
			'@media (hover: none)': {
				display: 'inline-flex',
				opacity: touchEditVisible ? 1 : 0,
				pointerEvents: touchEditVisible ? 'auto' : 'none'
			}
		}
	}),

	iconButton: (touchEditVisible: boolean) => (theme: Theme) => ({
		display: 'none',
		alignSelf: 'center',
		color: 'grey.600',
		fontSize: '1.125rem',
		padding: 0.5,
		opacity: touchEditVisible ? 1 : 0,
		pointerEvents: touchEditVisible ? 'auto' : 'none',
		transition: 'opacity 120ms ease-in-out',
		[theme.breakpoints.down('md')]: {
			'@media (hover: none)': {
				display: 'inline-flex'
			}
		}
	})
};
